// extracted by mini-css-extract-plugin
export var active = "_cg-7";
export var container = "_cg-0";
export var evenWidth = "_cg-4";
export var large = "_cg-5";
export var outlet = "_cg-8";
export var slide = "_cg-2";
export var small = "_cg-6";
export var tab = "_cg-3";
export var tabs = "_cg-1";